module.exports = __webpack_public_path__ + "img/home-production-01.3ecb4dfc.png";